export default "__VITE_ASSET__3d1bd1c4__"